import React from 'react';
import { useSelector } from 'react-redux';

// @ts-ignore
import { useToken } from 'utils/utility';

// @ts-ignore
import { chatNodeRequest, chatNodePull } from '../../api';
import { isStaging, isProduction } from '../../config';

import { ChatWidget } from './ChatWidget';

interface SetupProps {
  // Optional props to override default behavior
  token?: string;
  userDetail?: any;
  env?: string;
  envSuffix?: string;
}

/**
 * Setup - A wrapper component that handles the setup and configuration
 * of the ChatWidget. This separates the concerns of authentication, environment
 * detection, and user state management from the core ChatWidget component.
 * 
 * This allows the ChatWidget to be used in different projects with different
 * authentication mechanisms by simply providing the required props.
 */
export const Setup: React.FC<SetupProps> = ({
  token: providedToken,
  userDetail: providedUserDetail,
  env: providedEnv,
  envSuffix: providedEnvSuffix
}) => {
  // Get user details and token from Redux/hooks if not provided
  const { userDetail: reduxUserDetail } = useSelector((state: any) => state.userDetailReducer);
  const { token: hookToken } = useToken();

  // Use provided values or fall back to defaults
  const token = providedToken || hookToken;
  const userDetail = providedUserDetail || reduxUserDetail;
  
  // Determine environment values
  const env = providedEnv || (isProduction ? 'production' : isStaging ? 'staging' : 'dev');
  const envSuffix = providedEnvSuffix || (isProduction ? 'Production' : isStaging ? 'Staging' : 'Dev');

  // Don't render if user is not authenticated
  if (!userDetail || !userDetail.id || !token) {
    return null;
  }

  return (
    <ChatWidget
      token={token}
      env={env}
      envSuffix={envSuffix}
      chatNodeRequest={chatNodeRequest}
      chatNodePull={chatNodePull}
    />
  );
};
